// =====================================================================
// canhBaoCau.ts — cảnh báo Admin khi cầu đồng bộ lỗi / không chạy (rà soát 02/11/2026, Le duyệt; dữ liệu: rpc_dong_bo_suc_khoe — 0358).
// Luật (đỏ = banner trên mọi màn cho Admin; vàng = chỉ hiện ở Cài đặt › Đồng bộ):
//   1. ĐỎ  Cầu không chạy: có ít nhất 1 công tắc bật mà quá NHIP_TOI_DA_PHUT không có nhịp (cầu kiểm mỗi 10 phút).
//   2. ĐỎ  Lượt gần nhất của việc đang bật (Lấy / Ghi) của 1 nguồn bị LỖI.
//   3. ĐỎ  Lấy: đã qua 1 mốc giờ lấy quá TRE_MOC_PHUT mà chưa có lượt Lấy nào sau mốc đó (lỡ mốc).
//   4. ĐỎ  Ghi: trong khung giờ ghi, quá GHI_TOI_DA_GIO (cầu tự đọc lại sheet ít nhất mỗi 6 giờ dù web không đổi) + 30 phút không có lượt Ghi.
//   5. VÀNG Lượt gần nhất bị TỪ CHỐI (vd sheet Dashboard cũ / số dòng tụt bất thường — nguồn giữ dữ liệu cũ, không ghi gì).
// Giờ tính theo VN (UTC+7, không đổi giờ mùa hè). THUẦN: không React, không mạng, bây giờ truyền vào.
// =====================================================================
// Không import core khác: module này vào gói JS ban đầu (banner trên mọi màn) — giữ nhẹ.

/** "07:00-22:00" ⇒ [420, 1320] phút; sai dạng ⇒ null (y CauCore.docKhungGio của cầu: nhận cả "7h00"). */
export function docKhungGhi(v: string): [number, number] | null {
  const m = /^\s*(\d{1,2})[:hH](\d{2})\s*[-–]\s*(\d{1,2})[:hH](\d{2})\s*$/.exec(v);
  if (!m || +m[1] > 24 || +m[3] > 24 || +m[2] > 59 || +m[4] > 59) return null;
  const a = +m[1] * 60 + +m[2], b = +m[3] * 60 + +m[4];
  return a < b ? [a, b] : null;
}

export type NguonCau = "IM" | "CU" | "DASHBOARD" | "TAC_VU";
const NGUON: readonly NguonCau[] = ["IM", "CU", "DASHBOARD", "TAC_VU"];
const TEN: Record<NguonCau, string> = { IM: "File kiểm soát IM", CU: "File kiểm soát CU", DASHBOARD: "Sheet Dashboard", TAC_VU: "Tác vụ GV (Demo + Mapping)" };

export const NHIP_TOI_DA_PHUT = 60;
export const TRE_MOC_PHUT = 60;
export const GHI_TOI_DA_GIO = 6;
const MOC_LAY_MAC_DINH = ["04:00", "12:30", "19:00"];
const KHUNG_GHI_MAC_DINH = "07:00-22:00";
const LECH_VN = 7 * 3_600_000;
const NGAY = 86_400_000;

export interface LuotCau { nguon: NguonCau; viec: "LAY" | "GHI"; batDau: string; trangThai: "XONG" | "LOI" | "TU_CHOI"; loi: string | null }
export interface SucKhoeCau {
  nhipLuc: string | null;
  congTac: Record<NguonCau, { lay: boolean; ghi: boolean }>;
  mocLay: string[];
  khungGhi: string;
  luot: LuotCau[];
}
export interface CanhBaoCau { muc: "do" | "vang"; nguon: NguonCau | null; chu: string }

const laObj = (v: unknown): v is Record<string, unknown> => !!v && typeof v === "object" && !Array.isArray(v);
const hhmm = (s: string) => { const m = /^(\d{1,2}):(\d{2})$/.exec(s.trim()); return m && +m[1] < 24 && +m[2] < 60 ? +m[1] * 60 + +m[2] : null; };

/** Gói rpc_dong_bo_suc_khoe ⇒ dạng dùng được; trường lạ / thiếu ⇒ mặc định (không vỡ màn). */
export function docSucKhoe(g: unknown): SucKhoeCau {
  const o = laObj(g) ? g : {};
  const ct = laObj(o.cong_tac) ? o.cong_tac : {};
  const ts = laObj(o.tham_so) ? o.tham_so : {};
  const congTac = {} as SucKhoeCau["congTac"];
  for (const n of NGUON) {
    const x = laObj(ct[n]) ? (ct[n] as Record<string, unknown>) : {};
    congTac[n] = { lay: x.lay === true, ghi: x.ghi === true };
  }
  const moc = Array.isArray(ts.moc_lay) ? ts.moc_lay.filter((x): x is string => typeof x === "string" && hhmm(x) !== null) : [];
  const luot: LuotCau[] = [];
  for (const r of Array.isArray(o.luot) ? o.luot : []) {
    if (!laObj(r)) continue;
    const nguon = r.nguon as NguonCau, viec = r.viec, tt = r.trang_thai;
    if (!NGUON.includes(nguon) || (viec !== "LAY" && viec !== "GHI") || (tt !== "XONG" && tt !== "LOI" && tt !== "TU_CHOI") || typeof r.bat_dau !== "string") continue;
    luot.push({ nguon, viec, batDau: r.bat_dau, trangThai: tt, loi: typeof r.loi === "string" ? r.loi : null });
  }
  return {
    nhipLuc: typeof o.nhip_luc === "string" ? o.nhip_luc : null,
    congTac,
    mocLay: moc.length ? moc : MOC_LAY_MAC_DINH,
    khungGhi: typeof ts.khung_gio_ghi === "string" && docKhungGhi(ts.khung_gio_ghi) ? ts.khung_gio_ghi : KHUNG_GHI_MAC_DINH,
    luot,
  };
}

/** "HH:mm" giờ VN của 1 thời điểm (+ " dd/mm" nếu khác ngày với bây giờ). */
function gioVn(ms: number, bayGio: number): string {
  const d = new Date(ms + LECH_VN), h = new Date(bayGio + LECH_VN);
  const p = (n: number) => String(n).padStart(2, "0");
  const gio = `${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
  return d.getUTCDate() === h.getUTCDate() && d.getUTCMonth() === h.getUTCMonth() ? gio : `${gio} ${p(d.getUTCDate())}/${p(d.getUTCMonth() + 1)}`;
}

/** Mốc lấy gần nhất ĐÃ QUA (ms UTC) — y luật cầu (CauCore.mocDaQua): chưa tới mốc đầu ngày ⇒ mốc cuối hôm trước. */
export function mocLayDaQua(mocLay: readonly string[], bayGio: number): { ms: number; ten: string } {
  const phut = mocLay.map(hhmm).filter((x): x is number => x !== null).sort((a, b) => a - b);
  const ds = phut.length ? phut : MOC_LAY_MAC_DINH.map((x) => hhmm(x)!);
  const vn = bayGio + LECH_VN;
  let dauNgay = Math.floor(vn / NGAY) * NGAY;
  const bay = Math.floor((vn - dauNgay) / 60_000);
  let chon = ds.filter((m) => m <= bay).pop();
  if (chon === undefined) { chon = ds[ds.length - 1]; dauNgay -= NGAY; }
  const p = (n: number) => String(n).padStart(2, "0");
  return { ms: dauNgay + chon * 60_000 - LECH_VN, ten: `${p(Math.floor(chon / 60))}:${p(chon % 60)}` };
}

const tenViec = (v: "LAY" | "GHI") => (v === "LAY" ? "Lấy" : "Ghi");

export function canhBaoCau(sk: SucKhoeCau, bayGio: number): CanhBaoCau[] {
  const out: CanhBaoCau[] = [];
  const coBat = NGUON.some((n) => sk.congTac[n].lay || sk.congTac[n].ghi);
  if (!coBat) return out;

  // 1. nhịp (chưa có nhịp = chưa chạy migration / cầu chưa gọi lần nào ⇒ không kết luận)
  if (sk.nhipLuc) {
    const t = Date.parse(sk.nhipLuc);
    if (t === t && bayGio - t > NHIP_TOI_DA_PHUT * 60_000) {
      out.push({ muc: "do", nguon: null, chu: `Cầu Apps Script không chạy từ ${gioVn(t, bayGio)} — kiểm Triggers / Executions của project "Cầu đồng bộ Web vận hành"` });
    }
  }

  const ganNhat = (n: NguonCau, v: "LAY" | "GHI") => sk.luot.find((l) => l.nguon === n && l.viec === v) ?? null;
  for (const n of NGUON) {
    const ct = sk.congTac[n];
    // Lấy + Ghi cùng bật: cầu từ chối chạy cả hai (QĐ-H3) — màn Đồng bộ đã chặn gạt như vậy; báo cho rõ nếu dữ liệu cũ còn sót
    if (ct.lay && ct.ghi) { out.push({ muc: "do", nguon: n, chu: `${TEN[n]}: đang bật cả Lấy và Ghi — cầu không chạy nguồn này` }); continue; }
    const viecBat: Array<"LAY" | "GHI"> = ct.lay ? ["LAY"] : ct.ghi && n !== "DASHBOARD" && n !== "TAC_VU" ? ["GHI"] : [];
    for (const v of viecBat) {
      const l = ganNhat(n, v);
      if (l?.trangThai === "LOI") {
        out.push({ muc: "do", nguon: n, chu: `${TEN[n]}: lượt ${tenViec(v)} lúc ${gioVn(Date.parse(l.batDau), bayGio)} bị lỗi${l.loi ? " — " + l.loi : ""}` });
      } else if (l?.trangThai === "TU_CHOI") {
        out.push({ muc: "vang", nguon: n, chu: `${TEN[n]}: lượt ${tenViec(v)} lúc ${gioVn(Date.parse(l.batDau), bayGio)} bị từ chối${l.loi ? " — " + l.loi : ""}` });
      }
      const cuoi = l ? Date.parse(l.batDau) : NaN;
      if (v === "LAY") {
        const moc = mocLayDaQua(sk.mocLay, bayGio);
        if (bayGio - moc.ms > TRE_MOC_PHUT * 60_000 && !(cuoi >= moc.ms)) {
          out.push({ muc: "do", nguon: n, chu: `${TEN[n]}: lỡ mốc lấy ${moc.ten} — chưa có lượt Lấy nào sau mốc này` });
        }
      } else {
        const k = docKhungGhi(sk.khungGhi) ?? docKhungGhi(KHUNG_GHI_MAC_DINH)!;
        const vn = bayGio + LECH_VN, dauNgay = Math.floor(vn / NGAY) * NGAY, phut = Math.floor((vn - dauNgay) / 60_000);
        if (phut >= k[0] && phut < k[1]) {
          const moKhung = dauNgay + k[0] * 60_000 - LECH_VN;
          const tu = cuoi === cuoi ? Math.max(cuoi, moKhung) : moKhung;
          if (bayGio - tu > (GHI_TOI_DA_GIO * 60 + 30) * 60_000) {
            out.push({ muc: "do", nguon: n, chu: `${TEN[n]}: chưa có lượt Ghi nào từ ${gioVn(tu, bayGio)} (quá ${GHI_TOI_DA_GIO} giờ trong khung giờ ghi)` });
          }
        }
      }
    }
  }
  return out;
}
